var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Ooyala = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.player) {
      return this.player.getPlayheadTime()
    }
    return this.playhead
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this.player) {
      return this.player.getDuration()
    }
    return this.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (this.player) {
      return this.player.getCurrentBitrate()
    }
    return this.bitrate
  },

  /** Override to return rendition */
  getRendition: function () {
    return this.rendition
  },

  /** Override to return title */
  getTitle: function () {
    if (this.player) {
      return this.player.getTitle()
    }
    return this.title
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.isLive
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.resource || "unknown"
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return OO.VERSION.core.rev
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Ooyala"
  },

  processEvent: function (eventName, params) {
    try {
      if (eventName !== "video_stream_position_changed") youbora.Log.debug(eventName)
      if (!this.isShowingAds) {
        switch (eventName) {
          case "video_stream_position_changed":
            this.fireJoin()
            this.playhead = params[0].streamPosition
            this.duration = params[0].totalStreamDuration
            if (this.seekReady) {
              this.fireSeekEnd()
            }
            break
          case "video_play_requested":
          case "initial_playback_requested":
          case "video_replay_requested":
            if (!this.flags.isStarted) {
              this.monitorPlayhead(true, false)
              this.playhead = null
            }
            if (!this.plugin.getAdsAdapter()) {
              this.plugin.setAdsAdapter(new youbora.adapters.Ooyala.AdsAdapter())
              this.adsAdapter = this.plugin.getAdsAdapter()
            }
            if (!this.crashed) this.fireStart()
            this.crashed = false
            break
          case "video_buffering_ended":
            this.fireJoin()
            break
          case "video_pause_requested":
            this.firePause()
            break
          case "initialPlayStarting":
          case "video_playing":
            this.fireJoin()
            this.fireResume()
          case "video_seek_completed":
            this.seekReady = true
            break
          case "video_seek_requested":
            this.fireSeekBegin()
            this.seekReady = false
            break
          case "ad_break_started":
            this.firePause()
            this.isShowingAds = true
            break
          //case "ad_break_ended":
          //   this.isShowingAds = false // will be set by the adsadapter
          //  break
          case "destroy":
          case "playback_completed":
            this.fireStop()
            this.monitor.stop()
            break
          case "video_content_metadata_updated":
            this.title = params[0].title
            this.duration = params[0].duration / 1000
            break
          case "video_element_created":
            this.resource = params[0].streamUrl
            break
          case "stream_type_updated":
            this.isLive = !(params[0].streamType == "vod")
            break
          case "bitrateInitial":
          case "bitrate_initial":
          case "video_stream_bitrate_changed":
            this.bitrate = params[0].bitrate
            if (isNaN(params[0].id)) {
              this.rendition = params[0].id
            } else if (params[0].width && params[0].height && params[0].bitrate) {
              this.rendition = youbora.Util.buildRenditionString(params[0].width, params[0].height, params[0].bitrate)
            } else {
              this.rendition = null
            }
            break
          case "error":
          case "authorization_error":
          case "video_playback_error":
            this.fireError(params[0].errorCode, params[0].errorMessage)
            if (params[0].errorCode === "stream") {
              this.fireStop()
              this.crashed = true
            }
            break
          case "adRequestError":
            this.fireError(params[0].errorCodes.errorCode, params[0].errorMessage)
            break
        }
      }
      if (this.adsAdapter && this.isShowingAds) this.adsAdapter.processEvent(eventName, params)
    } catch (error) {
      youbora.Log.error(error)
    }
  }
}, {
    AdsAdapter: require('./ads/adsadapter')
  }
)

module.exports = youbora.adapters.Ooyala



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 29
// module chunks = 0